import $ from "jquery";
import {animateDiv} from "./animationFunctions";
import "../../styles/first_page.scss";

$(document).ready(async function () {
    const imgLink = document.querySelector('#bed-storizz'),
        z = $('.z'),
        linkButton = document.querySelector('#start-here');
    // console.log(imgLink);
    imgLink.addEventListener('mouseover', function () {
        imgLink.classList.add('vibrate');
        z.removeClass('hidez');
    });
    imgLink.addEventListener('mouseout', function () {
        imgLink.classList.remove('vibrate');
        z.addClass('hidez');
    });
    function goToConfigurator() {
        try {
            // Mark this navigation as coming from the start button so the configurator entry guard
            // (see configurator.html) lets it through instead of redirecting back to the start page.
            sessionStorage.setItem('configuratorEntry', 'button');
        } catch (e) { /* sessionStorage unavailable */ }
        let url = window.location.href.split("?")[0] + "configurator/";
        let params = new URLSearchParams(window.location.search);
        let paramsString = params.toString();
        if (paramsString) {
            url = url + "?" + paramsString;
        }
        window.location.href = url;
    }

    linkButton.addEventListener('click', goToConfigurator);
    imgLink.addEventListener('click', goToConfigurator);
    for (let i = 1; i < 7; i++) {
        animateDiv($(`#image-${i}`));
    }

});